import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "677",
  height: "283",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "url(#a)",
  d: "M.298 229.04v-41.8L124.558 9.4h61.94v173.28h33.44v46.36h-33.44V283h-53.2v-53.96zM136.718 66.4l-77.9 116.28h77.9zm97.09 74.48q0-65.74 23.56-102.98Q281.308.66 336.408.66t78.66 37.24q23.94 37.24 23.94 102.98 0 66.12-23.94 103.74-23.56 37.62-78.66 37.62t-79.04-37.62q-23.56-37.62-23.56-103.74m152.76 0q0-28.12-3.8-47.12-3.42-19.38-14.44-31.54-10.64-12.16-31.92-12.16t-32.3 12.16q-10.64 12.16-14.44 31.54-3.42 19-3.42 47.12 0 28.88 3.42 48.64 3.42 19.38 14.44 31.54 11.02 11.78 32.3 11.78t32.3-11.78q11.02-12.16 14.44-31.54 3.42-19.76 3.42-48.64m70.624 88.16v-41.8L581.452 9.4h61.94v173.28h33.44v46.36h-33.44V283h-53.2v-53.96zM593.612 66.4l-77.9 116.28h77.9z",
  opacity: ".06"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "a",
    x1: "336.5",
    x2: "336.5",
    y1: "17",
    y2: "283",
    gradientUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#FDFDFD" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#FDFDFD",
      "stop-opacity": ".2"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }